import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overflow-x-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0 break-word justify-center" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "break-word" }, "Số lượng")
], -1)
const _hoisted_3 = {
  key: 1,
  class: "mb-0 break-word text-end"
}
const _hoisted_4 = { class: "break-word" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Đơn giá")
], -1)
const _hoisted_6 = { class: "text-end mb-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0 break-word" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "break-word" }, "Thành tiền")
], -1)
const _hoisted_8 = { class: "text-end mb-0 break-word" }
const _hoisted_9 = { class: "break-word" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 break-word" }, "Ghi chú", -1)
const _hoisted_11 = {
  key: 0,
  class: "d-flex align-items-center justify-content-center flex-wrap h-100"
}
const _hoisted_12 = { class: "d-flex justify-content-center flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_QuantityInputCustom = _resolveComponent("QuantityInputCustom")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_VatTuTable = _resolveComponent("VatTuTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VatTuTable, {
      "is-loading": _ctx.isLoading,
      items: _ctx.vatTuItems,
      "table-class": "min-w-full"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "Thu hồi",
          width: _ctx.columnWidths.thuHoi
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.vatTuItems[scope.$index].thu_hoi,
              "onUpdate:modelValue": ($event: any) => ((_ctx.vatTuItems[scope.$index].thu_hoi) = $event),
              disabled: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }, 8, ["width"]),
        _createVNode(_component_el_table_column, {
          label: "C/ty quản lý",
          width: _ctx.columnWidths.congTyQuanLy
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.vatTuItems[scope.$index].cong_ty_duyet,
              "onUpdate:modelValue": ($event: any) => ((_ctx.vatTuItems[scope.$index].cong_ty_duyet) = $event),
              disabled: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }, 8, ["width"]),
        _createVNode(_component_el_table_column, {
          width: _ctx.columnWidths.soLuong,
          "class-name": "amount-cell",
          "header-align": "center"
        }, {
          header: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx((scope) => [
            (_ctx.isSoLuongEditable)
              ? (_openBlock(), _createBlock(_component_QuantityInputCustom, {
                  key: 0,
                  modelValue: scope.row.so_luong,
                  "onUpdate:modelValue": ($event: any) => ((scope.row.so_luong) = $event),
                  "class-str": "w-100",
                  min: 0,
                  placeholder: "Nhập số lượng",
                  onFocus: ($event: any) => (_ctx.onSoLuongFocus(scope.row)),
                  onChange: (value) => _ctx.onSoLuongChanged(scope.row, value)
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onChange"]))
              : (_openBlock(), _createElementBlock("p", _hoisted_3, [
                  _createElementVNode("strong", _hoisted_4, _toDisplayString(_ctx.soLuongDisplay(scope.$index)), 1)
                ]))
          ]),
          _: 1
        }, 8, ["width"]),
        (_ctx.showPriceAndTotal)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              width: _ctx.columnWidths.donGia,
              "header-align": "center"
            }, {
              header: _withCtx(() => [
                _hoisted_5
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("p", _hoisted_6, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.formatUnitPrice(scope.row.pivot?.don_gia ?? scope.row.don_gia)), 1)
                ])
              ]),
              _: 1
            }, 8, ["width"]))
          : _createCommentVNode("", true),
        (_ctx.showPriceAndTotal)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              width: _ctx.columnWidths.thanhTien,
              "header-align": "center"
            }, {
              header: _withCtx(() => [
                _hoisted_7
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("p", _hoisted_8, [
                  _createElementVNode("strong", _hoisted_9, _toDisplayString(_ctx.formatAmount(
                  _ctx.calcLineAmount(
                    parseFloat(scope.row.pivot?.don_gia ?? scope.row.don_gia),
                    scope.row.so_luong
                  )
                )), 1)
                ])
              ]),
              _: 1
            }, 8, ["width"]))
          : _createCommentVNode("", true),
        (_ctx.showGhiChuInput)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              "min-width": String(_ctx.columnWidths.ghiChu),
              "header-align": "center"
            }, {
              header: _withCtx(() => [
                _hoisted_10
              ]),
              default: _withCtx((scope) => [
                _createVNode(_component_el_input, {
                  modelValue: scope.row.ghi_chu,
                  "onUpdate:modelValue": ($event: any) => ((scope.row.ghi_chu) = $event),
                  disabled: _ctx.disableGhiChuInput,
                  onInput: (value) => _ctx.updateGhiChu(value, scope.row.id),
                  placeholder: _ctx.disableGhiChuInput ? '' : 'Ghi chú',
                  rows: 2,
                  type: "textarea"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onInput", "placeholder"])
              ]),
              _: 1
            }, 8, ["min-width"]))
          : _createCommentVNode("", true),
        (_ctx.isDeleteButtonDisplay && _ctx.vatTuItems.length)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 3,
              fixed: "right",
              width: _ctx.columnWidths.actions,
              align: "center"
            }, {
              default: _withCtx((scope) => [
                (_ctx.isDeleteButtonDisplaying(scope.$index))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_ButtonCustom, {
                        "button-type": _ctx.ButtonsType.TRASH,
                        "color-type": _ctx.ButtonTypeColors.DANGER,
                        "tooltip-message": "xoá v/tư đã nhập",
                        onClick: ($event: any) => (_ctx.onDeleteVatTu(scope.row.id))
                      }, null, 8, ["button-type", "color-type", "onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["width"]))
          : _createCommentVNode("", true),
        (_ctx.isInfoButtonDisplay)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 4,
              fixed: "right",
              width: _ctx.columnWidths.actions,
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_ButtonCustom, {
                    "button-type": _ctx.ButtonsType.INFO,
                    "color-type": _ctx.ButtonTypeColors.INFO,
                    "tooltip-message": "Chi tiết v/tư",
                    onClick: ($event: any) => (_ctx.onDetailButtonClicked(scope.row.id))
                  }, null, 8, ["button-type", "color-type", "onClick"])
                ])
              ]),
              _: 1
            }, 8, ["width"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-loading", "items"])
  ]))
}